import React, { useMemo } from "react";
import { Result, Button } from "antd";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import authActions from "../../Restore/redux/auth/actions";
import cookieHelper from "../../Restore/library/helpers/cookieHelper";

const AccessPending = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const pending = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("pendingAccessRequest") || "null");
    } catch {
      return null;
    }
  }, []);

  const userDetails = cookieHelper.getUserDetails() || {};
  const serviceName =
    pending?.serviceName ||
    userDetails.pendingServiceName ||
    "the selected module";

  const handleLogout = () => {
    localStorage.removeItem("pendingAccessRequest");
    dispatch(authActions.logout());
    history.push("/signin");
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "#f5f5f5",
      }}
    >
      <Result
        status="info"
        title="Access request pending"
        subTitle={`Your request to join ${serviceName} is waiting for a program admin to approve it. You will not see that module until they assign a role.`}
        extra={[
          <Button type="primary" key="logout" onClick={handleLogout}>
            Sign out
          </Button>,
        ]}
      />
    </div>
  );
};

export default AccessPending;
